export enum DoorMaterial {
  A40 = 'A40 Galvanized Steel',
  A60 = 'A60 Galvanized Steel',
  CRS = 'CRS Cold Rolled Steel',
  G90 = 'G90 Galvanized Steel',
}
